/* tslint:disable */
import { Company } from './company';

/**
 */
export class GroupKeyCompanyUpdate {
    id?: number;
    name?: string;
    key?: string;
    companies?: Company[];
    type?: string;
}
